const formFields = [
  {
    key: 'functionName',
    label: 'Function / Type',
    type: 'text',
    isRequired: true,
  },
  {
    key: 'employeesRequired',
    label: 'Employees Required',
    type: 'number',
  },
  {
    key: 'numberToHire',
    label: 'Number To Hire',
    type: 'number',
  },
  {
    key: 'hiringLeadTime',
    label: 'Hiring Lead Time',
    type: 'time',
    decoratorWord: 'months',
  },
  {
    key: 'qualificationRequired',
    label: 'Qualifications / Requirements',
    type: 'textArea',
  },
];

export { formFields };
